<!--
 * @description: 积分兑换商品详情
 * @fileName: detail.vue
 * @date: 2023-08-29 18:29:02
!-->
<template>
    <div class="points-for-goods-detail">
        <div class="points-for-goods-detail-container">
            <div class="goods-banner">
                <div class="banner-left">
                    <el-carousel :autoplay="true" trigger="hover" height="256px">
                        <el-carousel-item v-if="(baseInfo.videoUrlDto && baseInfo.videoUrlDto.length>0 && baseInfo.videoUrlDto[0].coverURL )">
                            <div
                                class="video-cover"
                                v-if="(baseInfo.videoUrlDto && baseInfo.videoUrlDto.length>0 && baseInfo.videoUrlDto[0].coverURL )"
                            >
                                <img :src="baseInfo.videoUrlDto[0].coverURL" class="cover-bg">
                                <img src="@assets/play.png" class="playBtn" @click="playDialog=true" v-if="!playDialog"/>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item v-for="item in baseInfo.picUrlList" :key="item">
                            <img :src="item" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="goods-banner-right">
                    <p class="mb-16 title">{{baseInfo.name}}</p>
                    <p class="mb-16 desc" v-if="baseInfo.goodsSellingPoint">{{baseInfo.goodsSellingPoint}}</p>
                    <div class="sku-list" v-for="(item,index) in specificationInfoArr" :key="index">
                        <span class="name mb-16">{{item.name}}</span>
                        <div class="sku-right">
                            <span class="sku mb-16"
                            v-for="el in item.list"
                            :key="el.name"
                            :class="orderInfo[index+1] == el.name ? 'active':''"
                            @click="changeSpec(el,index)"
                        >{{el.name}}</span>
                        </div>
                    </div>
                     <p class="mb-16">
                        <span class="name">所需积分</span>
                        <span class="points">{{totalMoney}}积分</span>
                    </p>
                    <p class="mb-16">
                        <span class="name">兑换数量</span>
                        <el-input-number v-model="num" size="medium" :step="1" :precision="0"  :min="1" :max="max" label="描述文字"
                        ></el-input-number>
                    </p>
                    <div>
                        <button type="button" @click="toExchange()">立即兑换</button>
                    </div>
                </div>
            </div>
            <div class="goods-intro">
                <h2>商品详情</h2>
                <div class="goods-intro-content" v-html="baseInfo.description">

                </div>
            </div>
        </div>
        <!-- 收货地址 -->
        <el-dialog
            title="收货信息"
            class="receiving-goods-dialog"
            :visible.sync="dialogVisible"
            width="540px"
            :close-on-click-modal="false"
            :before-close="handleClose">
            <el-form ref="ruleForm" size="small" :model="form" label-width="114px" :rules="rules" v-if="dialogVisible">
                <el-form-item label="收货人姓名：" prop="receiver" >
                    <el-input v-model="form.receiver" placeholder="请输入收货人姓名" maxlength="30"  @input="form.receiver = form.receiver.trimLeft()"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="mobile" >
                    <el-input v-model.trim="form.mobile" placeholder="请输入手机号" maxlength="11"  @input="form.mobile = form.mobile.trim()"></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="cityId">
                    <el-row type="flex" justify="space-between">
                        <el-col class="selectItem">
                            <el-form-item prop="provinceId" style="margin-bottom:0">
                                <el-select v-model="form.provinceId" size="small" placeholder="选择省" @change="handleProvinceChange">
                                    <el-option
                                        v-for="item in provinceList"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col class="selectItem">
                            <el-form-item prop="cityId" style="margin-bottom:0">
                                <el-select v-model="form.cityId" size="small" placeholder="选择市" @change="handleCityChange">
                                    <el-option
                                        v-for="item in cityList"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col class="selectItem">
                            <el-form-item prop="areaId" style="margin-bottom:0">
                                <el-select v-model="form.areaId" size="small" placeholder="选择区/县">
                                    <el-option
                                        v-for="item in districtList"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="详细地址：" prop="addr">
                    <el-input type="textarea" v-model="form.addr" maxlength="50" placeholder="请输入详细地址"  @input="form.addr = form.addr.trimLeft()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose()">取 消</el-button>
                <el-button type="primary" @click="confirmExchange()">确定兑换</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            class="result-dialog"
            :visible.sync="resultDialogVisible"
            width="320px"
            :close-on-click-modal="false"
            :before-close="confirm">
            <p>{{tipText}}</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirm()">知道了</el-button>
            </span>
        </el-dialog>
        <el-dialog 
            :visible.sync="playDialog"
        
            >
            <player-video  v-if="playDialog" :videoId="baseInfo.videoList && baseInfo.videoList[0]"></player-video>
        </el-dialog>
    </div>
</template>
<script>
import {phoneValidator} from '@/utils/validator'
import PlayerVideo from './../components/player'
export default {
    data(){
        return{
            max:99,
            playDialog:false,
            source:'',//播放器
            integral:0,//可用积分
            baseInfo:{},
            saleInfo:{},
            num:1, //购买数量
            dialogVisible:false,
            resultDialogVisible:false,
            orderInfo:{  //选中商品的规格
                1:'',
                2:'',
            },
            form:{
                mobile:'',
                receiver:'',
                addr:'',
                provinceId:'',
                cityId:'',
                areaId:'',
            },
            specificationInfoArr:[],//商品规格信息
            tipText:'兑换成功，请耐心等待收货',
            provinceList:[],
            rules:{
                receiver: [
                    { required: true, message: '请输入收货人姓名', trigger: 'blur' },
                ],
                mobile: [
                    { required: true, message: '请输入正确的手机号', trigger: 'blur',validator : phoneValidator, },
                ],
                provinceId:{required:true,message:'请选择省',trigger:'change' },
                cityId:{required:true,message:'请选择市',trigger:'change' },
                areaId:{required:true,message:'请选择区/县',trigger:'change' },
                addr:{required:true,message:'请输入详细地址',trigger:'blur' },
            }
        }
    },
    components:{
        PlayerVideo
    },
    computed:{
        cityList(){
            if(this.form.provinceId){
                let findItem = this.provinceList.find(item => item.code === this.form.provinceId)
                return findItem && findItem.children
            }else{
                return []
            }
        },
        districtList(){
            if(this.form.cityId){
                let findItem = this.cityList.find(item => item.code === this.form.cityId)
                return findItem && findItem.children
            }else{
                return []
            }
        },
        totalMoney(){
            return Number(this.num) * this.saleInfo.salePrice || 0;
        }
    },
    watch:{
        orderInfo:{
            handler(){
                if(this.orderInfo['1'] && (this.specificationInfoArr.length==1 || (this.specificationInfoArr.length==2 && this.orderInfo['2']))){
                    const obj = this.filterSkuId();
                    this.saleInfo.salePrice = obj.salePrice;
                    this.max = obj.stocks;
                    if(this.num>this.max){
                        this.num = this.max;
                    }
                }
            },
            deep:true
        }
    },
    created(){
        this.getIntegralEditInfo();
        this.getRegionList()
        this.getUsablePoints();
    },
    methods:{
        // 确定兑换
        confirmExchange(){
            this.$refs.ruleForm.validate(async (valid) => {
                let skuId
                if(this.saleInfo.goodsSkuList.length>0){
                    const obj = this.filterSkuId();
                    skuId = obj.id;
                }
                if (valid) {
                    const res = await this.$api.integralMall.junpeiBuy({
                        ...this.form,
                        orderSource: 5, //订单类型 1:普通;3:推广;4:渠道分销(包括批量)5：积分;
                        realPay: this.totalMoney,
                        totalMoney: this.totalMoney,
                        goodsList: [{
                            goodsId:this.baseInfo.goodsId,
                            num:this.num,
                            salePrice:this.saleInfo.salePrice,
                            skuId:skuId,
                            goodsKinds:3,
                        }]
                    })
                    this.dialogVisible = false;
                    if(res.code==0){
                        this.resultDialogVisible = true;
                        this.tipText = '兑换成功，请耐心等待收货'
                        this.num = 1;
                        this.orderInfo = {
                            1:'',
                            2:'',
                        }
                        this.$refs.ruleForm.resetFields();
                        this.$refs.ruleForm.clearValidate();
                    }
                } else {
                    return false;
                }
            });
        },
        // 立即兑换
        toExchange(){
            if(this.specificationInfoArr.length>0){
                try{
                    this.specificationInfoArr.map((item,index)=>{
                    if(!this.orderInfo[index+1]){
                            throw new Error(item.name);
                        }
                    })
                }catch(err){
                    this.$message.warning('请选择'+ err.message)
                    return
                }
            }
            if(!this.num || (this.num<1)){
                this.$message.warning('请输入兑换数量');
                return
            }
            if(this.integral<this.totalMoney){
                this.resultDialogVisible = true;
                this.tipText = '您的积分不足'
                return
            }
            this.dialogVisible = true;
        },
        // 知道了
        confirm(){
            this.resultDialogVisible = false;
            if(this.tipText == '您的积分不足') return
            this.resultDialogVisible = false;
            this.$router.replace({
                path:'/integralMall'
            })
        },
        // 切换规格
        changeSpec(item,index){
            this.orderInfo[index+1] = item.name;
        },
        //筛选出符合规格
        filterSkuId(){
            let temp = [];
            this.specificationInfoArr.map((item,index)=>{
                temp.push({
                    key:item.name,
                    value:this.orderInfo[index+1]
                })
            })
            const obj = this.saleInfo.goodsSkuList.filter(el=>{
                if(JSON.stringify(el.specsGroup) == JSON.stringify(temp)){
                    return el
                }
            })
            return obj[0]
        },
        // 商品详情
        getIntegralEditInfo(){
            const params = {id:this.$route.query.id}
            this.$api.integralMall.getIntegralEditInfo({params}).then(res=>{
                if(res.code==0){
                    this.max = res.data.extra.stocks;
                    const {videoUrlDto,picUrl,picUrlList,name,goodsSellingPoint,description,goodsId,videoList} = res.data.baseInfo;
                    this.baseInfo = {videoUrlDto,picUrl,picUrlList,name,goodsSellingPoint,description,goodsId,videoList};
                    const {salePrice,goodsSkuList} = res.data.saleInfo;
                    this.saleInfo = {salePrice,goodsSkuList}
                    if(this.saleInfo.goodsSkuList && this.saleInfo.goodsSkuList.length > 0){
                        this.transformSpec();
                    }
                }
            })
        },
        // 组装规格格式
        transformSpec(){
            this.saleInfo.goodsSkuList.forEach((item1) => {
                if (item1.specsGroup.length && item1.specsGroup.length > 0) {
                    item1.specsGroup.forEach((item2, index2) => {
                        let obj = {
                            name: '',
                            list: []
                        }
                        if (this.specificationInfoArr.length < item1.specsGroup.length) {
                            obj.name = item2.key
                            this.specificationInfoArr.push(obj)
                        }
                        if (!this.specificationInfoArr[index2].list.some(item => item.name == item2.value)) {
                            this.specificationInfoArr[index2].list.push({
                                name: item2.value
                            })
                        }
                    })
                }
            })
        },
        handleClose(){
            this.dialogVisible = false;
            this.resultDialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.$refs.ruleForm.clearValidate();
        },
        // 可用积分
        getUsablePoints(){
            const branchId = localStorage.getItem('solutionInfo')?JSON.parse(localStorage.getItem('solutionInfo')).defaultBranchId:''
            this.$api.integralMall.getUsablePoints({
                saasId:localStorage.getItem('saasId'),
                branchId:branchId
            }).then(res=>{
                if(res.code==0){
                    this.integral = res.data;
                }
            })
        },
        // 省市区数据
        getRegionList(){
            this.$api.usercenter.getRegionList({type:1}).then(res => {
                if(res.success){
                    this.provinceList = Object.freeze(res.data)
                }
            })
        },
        handleProvinceChange(){
            this.form.cityId = ''
            this.form.areaId = ''
            this.$nextTick(() => {
                this.$refs.ruleForm.clearValidate(['cityId','areaId'])
            })
        },
        handleCityChange(){
            this.form.areaId = ''
            this.$nextTick(() => {
                this.$refs.ruleForm.clearValidate('areaId')
            })
        },
    }
}
</script>
<style lang="stylus" scoped>
.mb-16{
    margin-bottom:15px;
    margin-top:1px;
}
.sku-list{
    display:flex;
    .name{
        white-space nowrap;
    }
}
/deep/.el-carousel__button{
    width:4px;
    height:4px;
    border-radius:50%;
}
.points-for-goods-detail{
    overflow:hidden;
    background:#F8FAFF;
    .points-for-goods-detail-container{
        width:1200px;
        margin:20px auto 16px;
    }
    .goods-banner{
        background:#fff;
        padding:24px;
        display:flex;
        .banner-left{
            margin-right:16px;
            width:343px;
            height:256px;
            position:relative;
            img{
                width:343px;
                height:256px;
                object-fit:cover;
            }
            .video-cover{
                width:343px;
                height:256px;
                text-align:center;
                background:rgba(0,0,0,.9);
                .cover-bg{
                    width:auto;
                    max-width:100%;
                    height:256px;
                }
            }
            .playBtn{
                position:absolute;
                top:50%;
                left:50%;
                width:48px;
                height:48px;
                transform:translate(-50%,-50%);
                z-index:32;    
            }
        }
        .goods-banner-right{
            padding:8px 0 0;
            width:calc(100% - 360px);
            span{
                display:inline-block;
            }
            .title{
                font-size:20px;
                font-weight:500;
                line-height:20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .desc{
                color:#999;
                font-size:16px;
                line-height:16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .name{
                color:#999;
                font-size:16px;
                line-height:32px;
                height:32px;
                margin-right:12px;
            }
            .sku{
                padding:3px 18px;
                border:1px solid #CBCDD5;
                color:#5B5F6E;
                font-size:16px;
                margin-right:12px;
                line-height:24px;
                display:inline-block;
                box-sizing:border-box;
                &.active{
                    color:#1972FF;
                    border-color:#1972FF;
                }
                &:hover{
                    cursor:pointer;
                }
            }
            .points{
                color:#EB5042;
                font-size:20px;
                font-weight:500;
                line-height:20px;
            }
            /deep/.el-input-number--medium{
                width:130px;
                .el-input__inner{
                    height:32px;
                    line-height:32px;
                    font-size:16px;
                }
                .el-input-number__decrease,
                .el-input-number__increase{
                    width:32px;
                    background:#fff;
                    line-height:30px;
                    color:#CBCDD5;
                }
            }
            button{
                outline:none;
                appearance:none;
                border:none;
                color:#fff;
                font-size:16px;
                line-height:40px;
                font-weight:600;
                text-align:center;
                width: 122px;
                height: 40px;
                border-radius:4px;
                background: linear-gradient(211deg, #5E9DFE 0%, #1972FF 100%);
                &:hover{
                    cursor:pointer;
                }
            }
        }
    }
    .goods-intro{
        background:#fff;
        margin-top 16px;
        h2{
            padding:20px 24px 16px;
            font-size:16px;
            font-weight:600;
            border-bottom:1px solid #E7EAF3;
            position:relative;
            &::after{
                position:absolute;
                width:64px;
                height:4px;
                background:#1972ff;
                border-radius:2px;
                bottom:0;
                left:24px;
                content:'';
            }
        }
        .goods-intro-content{
            padding:18px 24px 24px;
        }
    }
    .receiving-goods-dialog{
        /deep/.el-dialog__header{
            padding:10px 16px;
            background:#F8FAFF;
            font-size:14px;
        }
        /deep/.el-dialog__body{
            padding:32px 32px 10px;
        }
        /deep/.el-dialog__footer{
            padding:0 32px 32px;
        }
    }
    .result-dialog{
        /deep/.el-dialog__header{
            padding:16px;
        }
        /deep/.el-dialog__body{
            padding:0 16px 16px;
        }
        /deep/.el-dialog__footer{
            padding-bottom:16px;
        }
        p{
            color:#666;
        }
    }
    /deep/.el-dialog__title{
        color:#333;
        font-weight:500;
    }
    /deep/.el-dialog__header{
        font-weight:500;;
        border-radius:8px 8px 0 0;
    }
    /deep/.el-dialog__body{
        border-radius:0 0 8px 8px;
    }
    /deep/.el-form-item__label{
        color:#333;
    }
    /deep/.el-dialog__headerbtn{
        top:14px;
        right:18px;
        .el-dialog__close{
            color:#778BA2;
        }
    }
    /deep/.dialog-footer{
        .el-button{
            width:88px;
            height:32px;
            line-height:32px;
            padding:0;
            text-align:center;
        }
        .el-button+.el-button{
            margin-left:24px;
        }
        .el-button--primary{
            background: #1972FF linear-gradient(211deg, #5E9DFE 0%, #1972FF 100%);
        }
    }
    /deep/.selectItem{
        margin-right:10px;
        &:nth-last-child(1){
            margin-right:0;
        }
    }
}
</style>

